import {
    VENDOR_LOG_CREATE,
    VENDOR_LOG_CREATE_FAIL,
    VENDOR_LOG_CREATE_SUCCESS,
    RESET,
    RESET_VENDOR_LOG_CREATE,
    GET_VENDOR_LOG_DETAILS,
    GET_VENDOR_LOG_DETAILS_SUCCESS,
    GET_VENDOR_LOG_DETAILS_FAIL,
    UPDATE_VENDOR_LOG,
    UPDATE_VENDOR_LOG_SUCCESS,
    UPDATE_VENDOR_LOG_FAIL,
    DELETE_VENDOR_LOG,
    DELETE_VENDOR_LOG_SUCCESS,
    DELETE_VENDOR_LOG_FAIL,
    RESET_VENDOR_LOG_DETAILS,
} from "./actionsTypes";

const initialState = {
    vendorLogList: [],
    vendorLogDetails: {},
    createResult: {},
    deleteResult: {},
    loading: false,
    detailsLoading: false,
    loadingCreate: false,
    error: {
        message: "",
    },
};

const VendorLogReducer = (state = initialState, action) => {
    if (!action) return state;

    switch (action.type) {
        case VENDOR_LOG_CREATE:
            state = { ...state, createResult: {}, loadingCreate: true };
            break;
        case VENDOR_LOG_CREATE_SUCCESS:
            state = { ...state, createResult: action.payload, loadingCreate: false };
            break;
        case VENDOR_LOG_CREATE_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                createResult: {},
                loadingCreate: false,
            };
            break;

        //GET individual Vendor Log
        case GET_VENDOR_LOG_DETAILS:
            state = { ...state, detailsLoading: true, vendorLogDetails: {} };
            break;
        case GET_VENDOR_LOG_DETAILS_SUCCESS:
            state = { ...state, vendorLogDetails: action.payload, detailsLoading: false };
            break;
        case GET_VENDOR_LOG_DETAILS_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                detailsLoading: false,
            };
            break;

        //Update individual Vendor Log
        case UPDATE_VENDOR_LOG:
            state = { ...state, createResult: {}, loading: true };
            break;
        case UPDATE_VENDOR_LOG_SUCCESS:
            state = { ...state, createResult: action.payload, loading: false };
            break;
        case UPDATE_VENDOR_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false
            };
            break;

        //Delete individual Vendor Log
        case DELETE_VENDOR_LOG:
            state = { ...state, deleteResult: {}, loading: true, };
            break;
        case DELETE_VENDOR_LOG_SUCCESS:
            state = { ...state, deleteResult: action.payload, loading: false };
            break;
        case DELETE_VENDOR_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
                deleteResult: {}
            };
            break;

        //Reset Vendor Log
        case RESET_VENDOR_LOG_DETAILS:
            state = { ...state, vendorLogDetails: {}, loading: false };
            break;

        case RESET:
            state = { ...state, vendorLogList: [], createResult: {} };
            break;
        case RESET_VENDOR_LOG_CREATE:
            state = { ...state, createResult: {} };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default VendorLogReducer;